<template>
<div>
    <div v-if="show" class="curriculumList padding-20 bgc box-shadow">
        <div class="filters">
            <div class="add">
                <!-- <el-button  type="primary" @click="handleMechanism">机构维护</el-button> -->
                <el-button  type="primary" @click="handleTeacher">老师维护</el-button>
                <el-button v-if="permission.btnList.indexOf('A020701')==-1" type="primary" @click="handleAdd">发布课程</el-button>
                <el-button  type="primary" @click="openRecomDialog">推荐排序</el-button>
            </div>
            <div class="search">
                <el-select v-model="param.status" placeholder="上架状态" class="condition" clearable>
                    <el-option v-for="item in typeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                </el-select>
                <el-select v-model="param.isinnerrecomm" placeholder="推荐状态" class="condition" clearable>
                    <el-option v-for="item in isinnerrecommList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                </el-select>
                <el-input v-model="param.subject" placeholder="请输入课程名称" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="subject" label="课程名称" width="360px" class-name="title" >
                    <template slot-scope="scope">

                        <div class="imageText">
                            <img v-lazy="scope.row.coverurl" :alt="scope.row.subject" preview="videoList">
                            <div class="imageText-summary">
                                <div class="textBox">
                                    <div class="text">
                                        <span class="recommon" v-if="scope.row.isinnerrecomm === 1">推荐</span>{{ scope.row.subject }}
                                    </div>
                                </div>
                                <div class="price">
                                    <span v-if="scope.row.ispublic === 0" style="padding-right: 10px;">不公开</span>
                                    <span style="padding-right: 10px;">{{scope.row.coursetypetext}}</span>
                                    <span v-if="scope.row.feetype === 1">免费</span>
                                    <span v-else>￥{{scope.row.saleprice}}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="ordercount" label="订购量" class-name="center"></el-table-column>
                <el-table-column prop="viewcount" label="访问量" class-name="center"></el-table-column>
                <el-table-column prop="status" label="上架状态" class-name="center">
                    <template slot-scope="scope">
                        <span :class="status(scope.row.status)">.{{scope.row.status | status}}</span>
                        <el-tooltip :content="scope.row.memo" placement="top" v-if="scope.row.status == 11">
                            <div>
                                <i class="icon icon_warning"></i>
                            </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="coursestatus" label="课程状态" class-name="center">
                    <template slot-scope="scope">
                        <span style="color: #E6A23C" v-if="scope.row.coursestatus == 0">.{{scope.row.coursestatustext}}</span>
                        <span style="color: #67C23A" v-else>.{{scope.row.coursestatustext}}</span>
                        <!-- <span :class="status(scope.row.coursestatus)">.{{scope.row.coursestatustext | coursestatus}}</span> -->
                        <!-- <el-tooltip :content="scope.row.memo" placement="top" v-if="scope.row.coursestatus == 11"> -->
                            <!-- <div> -->
                                <!-- <i class="icon icon_warning"></i> -->
                            <!-- </div> -->
                        <!-- </el-tooltip> -->
                    </template>
                </el-table-column>
                <el-table-column prop="isinnerrecomm" label="推荐状态" class-name="center">
                    <template slot-scope="scope">
                        <span style="color: #E6A23C" v-if="scope.row.isinnerrecomm == 0">.{{scope.row.isinnerrecommname}}</span>
                        <span style="color: #67C23A" v-else>.{{scope.row.isinnerrecommname}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="上架时间" class-name="center" width="180"></el-table-column>
                <el-table-column label="操作"  width="260"  label-class-name="tr">
                    <template slot-scope="scope">
                        <div class="tr">
                            <span v-if="[1, 100].indexOf(scope.row.status)<=-1 && permission.btnList.indexOf('A020702')==-1">
                                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                                <span class="separator">|</span>
                            </span>
                            <span v-if="scope.row.status == 31 && permission.btnList.indexOf('A020703')==-1">
                                <el-button @click="handleUpperShelf(scope.row)" type="text" size="small">上架</el-button>
                                <span class="separator">|</span>
                            </span>
                            <span v-if="scope.row.status == 30 && permission.btnList.indexOf('A020704')==-1">
                                <el-button @click="handleLowerShelf(scope.row)" type="text" size="small">下架</el-button>
                                <span class="separator">|</span>
                            </span>
                            <span>
                                <Share :row='scope.row'></Share>
                            </span>
                            <span v-if="scope.row.coursetype == 2">
                                <el-button type="text" size="small" @click="goto('ChapterSetUp', scope.row.innerid)">章节设置</el-button>
                                <i class="separator">|</i>
                            </span>

                            <!-- <span v-if="scope.row.status == 10">
                                <el-button type="text" size="small" @click="goto('CurriculumPosterManagement', scope.row.innerid)">海报设置</el-button>
                                <i class="separator">|</i>
                            </span> -->

                            <span v-if="permission.btnList.indexOf('A020709')==-1 && scope.row.status == 10">
                                <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                            </span>

                            <el-dropdown v-if="scope.row.status !== 10">
                                <span class="el-dropdown-link separator">
                                    更多
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <!-- <el-dropdown-item @click.native="goto('CurriculumPosterManagement', scope.row.innerid)">海报设置</el-dropdown-item> -->
                                    <!-- <el-dropdown-item @click.native="goto('ShareSetUp', scope.row.innerid)">分享设置</el-dropdown-item> -->
                                    <el-dropdown-item @click.native="goCurrData(scope.row)">课程资料</el-dropdown-item>
                                    <el-dropdown-item @click.native="setCertificate(scope.row)" v-if="!scope.row.isopencert">设置证书</el-dropdown-item>
                                    <el-dropdown-item @click.native="editCertificate(scope.row)" v-if="scope.row.isopencert">编辑证书</el-dropdown-item>
                                    <el-dropdown-item @click.native="closeCertificate(scope.row)" v-if="scope.row.isopencert">关闭证书</el-dropdown-item>
                                    <el-dropdown-item @click.native="goCurrDataAny(scope.row)">数据分析</el-dropdown-item>
                                    <el-dropdown-item @click.native="goFormData(scope.row)" v-if="scope.row.isform">表单数据</el-dropdown-item>
                                    <el-dropdown-item v-if="scope.row.feetype === 2"  @click.native="toOrder(scope.row)">订单列表</el-dropdown-item>
                                    <el-dropdown-item  @click.native="goCurrComment(scope.row.innerid)">课程评价</el-dropdown-item>
                                    <el-dropdown-item  @click.native="goCurrNote(scope.row.innerid)">课程笔记</el-dropdown-item>
                                    <el-dropdown-item  @click.native="goCurrDiscuss(scope.row.innerid)">课程讨论</el-dropdown-item>
                                    <el-dropdown-item v-if="scope.row.status !== 12" @click.native="handleDel(scope.row)">删除课程</el-dropdown-item>
                                    <el-dropdown-item v-if="scope.row.status == 30 && scope.row.isinnerrecomm==0" @click.native="handleRecom(scope.row, 1)">设置推荐</el-dropdown-item>
                                    <el-dropdown-item v-if="scope.row.status == 30 && scope.row.isinnerrecomm==1" @click.native="handleRecom(scope.row, 0)">取消推荐</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" @getList="_getList" ref="page"></page>
        </div>
    </div>
    <recomDialog ref="recomDialog"></recomDialog>
    <ServiceAgreemengDialog @getList="_getList" ref="serviceAgreemengDialog" />
</div>
</template>

<script>
import {getAllCourseList, updateCourseByStatus, updateInnerRecomByCourse} from 'api/curriculumApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {videoMgtCode} from 'api/enumCode'
import Share from '@/base/share/share'
import {promiseUrlToQRCode, getCookie} from 'common/js/tools'
import {videoMsg} from 'api/message'
import {deleteCertInfo} from 'api/operateToolApi'
import RecomDialog from 'views/cms/curriculum/components/recomDialog.vue'
import ServiceAgreemengDialog from './components/serviceAgreemengDialog.vue'
export default {
    name: 'curriculumList',
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            typeList: [
                {code: '', name: '上架状态'},
                {code: '10', name: '待上架'},
                {code: '30', name: '已上架'},
                {code: '31', name: '已下架'}
            ],
            isinnerrecommList: [
                {code: '', name: '推荐状态'},
                {code: '1', name: '已推荐'},
                {code: '0', name: '未推荐'}
            ],
            total: 0,
            tableData: [],
            power: [],
            show: false
        }
    },
    props: ['param'],
    mounted() {
        this.power = this.permission.btnObj.A0207 ? this.permission.btnObj.A0207 : []
        if (getCookie('capwhaleOpenCourse')) {
            this._getList()
        } else {
            this.$refs.serviceAgreemengDialog.handleOpen()
        }
    },
    methods: {
        openRecomDialog() {
            this.$refs.recomDialog.openDialog()
        },
        // 设置证书
        setCertificate(item) {
            this.$router.push({
                name: 'certificateEdit',
                query: {
                    kmcinnerid: item.innerid,
                    kmctype: 7
                }
            })
        },
        // 编辑证书
        editCertificate(item) {
            this.$router.push({
                name: 'certificateEdit',
                query: {
                    innerid: item.certconfigid
                }
            })
        },
        closeCertificate(item) {
            this.$confirm('关闭后将无法恢复，确认关闭证书吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                deleteCertInfo({
                    data: {certinnerid: item.certconfigid},
                    success: res => {
                        this.setLoading(false)
                        item.isopencert = 0
                        this.$message.success('关闭证书成功')
                        console.log(res)
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {
                // 取消删除
            })
        },
        // 跳转到交易中心 下 订单管理
        toOrder(row) {
            // console.log(row)
            this.$router.push({name: 'Order', query: {kmctype: 7, kmcinnerid: row.innerid}})
        },
        goto(name, eventinnerid) {
            this.$router.push({name: name, query: {'innerid': eventinnerid}})
        },
        handleQuery() {
            this.setParams(this._.cloneDeep(this.param))
            this.$refs.page.handleSizeChange(1)
        },
        handleAdd() {
            if (this.shop.authstatus === 0) {
                this.$confirm('该功能需要在开通企业版或者单独工具基础上方可使用，建议尽快购买，购买后可继续使用该功能', '提示', {
                    confirmButtonText: '去购买',
                    cancelButtonText: '取消'
                }).then(() => {
                    // 去购买
                    this.$router.push({name: 'OrderService'})
                }).catch(() => {
                    // 取消
                })
            } else {
                this.$router.push({name: 'CurriculumEdit'})
            }
        },
        // 跳转至机构维护
        handleMechanism(){
            this.$router.push({name: 'MechanismEdit'})
        },
        // 跳转至老师维护
        handleTeacher(){
            this.$router.push({name: 'TeacherList'})
        },
        handleEdit(row) {
            this.$router.push({name: 'CurriculumEdit', query: {id: row.innerid}})
        },
        // 跳转至课程资料
        goCurrData(data){
            this.$router.push({name: 'CurriculumData',query: {innerid: data.innerid}})
        },
        // 跳转至数据分析
        goCurrDataAny(data){
            this.$router.push({name: 'CurriculumDataAny',query: {innerid: data.innerid}})
        },
        // 跳转至表单数据
        goFormData(data) {
            this.$router.push({name: 'FormData',query: {innerid: data.innerid}})
        },
        // 跳转至课程评价
        goCurrComment(id){
            this.$router.push({name: 'CurriculumComment',query: {innerid: id}})
        },
        goCurrNote(id){
            this.$router.push({name: 'CurriculumNote',query: {innerid: id}})
        },
        goCurrDiscuss(id){
            this.$router.push({name: 'CurriculumDiscuss',query: {innerid: id}})
        },
        handleDel(row) {
            let status = 100
            this.$confirm(videoMsg.del.msg, videoMsg.del.title, {
                confirmButtonText: videoMsg.del.confirmText,
                cancelButtonText: videoMsg.del.cancelText
            }).then(() => {
                this._editStatus(row.innerid, status, videoMsg.del.successMsg)
            }).catch(() => {})
        },
        handleRecom(row, type) {
            if (type == 1) {
                this.$confirm(videoMsg.addRec.msg, videoMsg.addRec.title, {
                    confirmButtonText: videoMsg.addRec.confirmText,
                    cancelButtonText: videoMsg.addRec.cancelText
                }).then(() => {
                    this._editRecom(row.innerid, type, videoMsg.addRec.successMsg)
                }).catch(() => {})
            } else {
                this.$confirm(videoMsg.removeRec.msg, videoMsg.removeRec.title, {
                    confirmButtonText: videoMsg.removeRec.confirmText,
                    cancelButtonText: videoMsg.removeRec.cancelText
                }).then(() => {
                    this._editRecom(row.innerid, type, videoMsg.removeRec.successMsg)
                }).catch(() => {})
            }
        },
        handleUpperShelf(row) {
            let status = 30
            this._editStatus(row.innerid, status, videoMsg.onShelf.successMsg)
        },
        handleLowerShelf(row) {
            let status = 31
            this.$confirm(videoMsg.offShelf.msg, videoMsg.offShelf.title, {
                confirmButtonText: videoMsg.offShelf.confirmText,
                cancelButtonText: videoMsg.offShelf.cancelText
            }).then(() => {
                this._editStatus(row.innerid, status, videoMsg.offShelf.successMsg)
            }).catch(() => {})
        },
        _editStatus(innerid, status, tip) {
            this.setLoading(true)
            updateCourseByStatus({
                data: {
                    innerid: innerid,
                    status: status
                },
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editRecom(innerid, optype, tip) {
            this.setLoading(true)
            updateInnerRecomByCourse({
                data: {
                    innerid: innerid,
                    optype: optype
                },
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getAllCourseList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.show = true
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.tableData.forEach(obj => {
                        promiseUrlToQRCode(obj.shareurl, obj.coverurl).then(
                            function(data) {
                                obj.qrShare = data
                            },
                            function(reason, data) {
                                console.log('二维码生成失败：', reason)
                            }
                        )
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {
        status: function (value) {
            for (let i = 0; i < videoMgtCode.status.length; i++) {
                if (value === videoMgtCode.status[i].code) {
                    return videoMgtCode.status[i].name
                }
            }
            return value
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                for (let i = 0; i < videoMgtCode.status.length; i++) {
                    if (value === videoMgtCode.status[i].code) {
                        return videoMgtCode.status[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([
            'page',
            'user',
            'permission',
            'params',
            'shop'
        ])
    },
    components: {
        Page, Share, RecomDialog, ServiceAgreemengDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.curriculumList {
    .add {
        .el-button {
            margin-left: 0;
            margin-right: 20px;
        }
    }
    .el-dropdown {
        cursor: pointer;
    }
    .btn-operate-list .separator {
        font-size: 12px;
        font-style:normal;
    }
    .tc-complete {
        color: rgb(230, 162, 60) !important;
    }
    .result-list{
        .share {
            display: inline-block;
        }
        .el-table__row{
            height: 100px;
        }
        .imageText{
            .imageText-summary{
                margin-left: 5px;
                .textBox{
                    width: 250px;
                    height: 40px;
                    line-height: 20px;
                    overflow: hidden;
                    .text{
                        // float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        // margin-left: -10px;
                        // width: 340px;
                        word-break: break-all;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        word-break: break-all;
                        // font-size: 0.48rem;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 5px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 40px;
                        line-height: 20px;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 37px;
                        margin-left: -30px;
                        position: relative;
                        left: 96%;
                        bottom: 20px;
                        font-weight: 600;
                        padding-right: 1px;
                        background: #fff;
                        transition: all 0.5s;
                    }
                    .recommon{
                        color: #fff;
                        background: #E6A23C;
                        display: inline-block;
                        width: 36px;
                        height: 16px;
                        line-height: 16px;
                        text-align: center;
                        margin-right: 5px;
                        font-size: 12px;
                    }
                }
                .price{
                    margin-left: 5px;
                    color: #F56C6C;
                }
            }
        }
        .el-table__row:hover{
            .textBox{
                &::after{
                    background: #F5F7FA;
                }
            }
        }
        img{
            min-width: 100px;
            max-width: 100px;
            height: 60px;
        }
        .icon{
            margin-left: 10px;
            width: 14px;
            height: 14px;
        }
    }
    .result-list .imageText .imageText-summary div:nth-child(1){
        margin-bottom: 0;
    }
    .el-table{
        .title{
            .cell{
                padding: 0;
                margin-left: 5px;
            }
        }
        .center{
            .cell{
                text-align: center;
            }
        }
    }
}
.el-popover{
    .videoList-pr-code-upload{
        text-align: center;
        img{
            width: 160px;
            height: 160px;
        }
        .pr-code-text{
            color: $tcolor-blue;
            padding: 20px 0;
        }
        .btn-operate{
            @include flexBox(space-between);
            .el-input,input{
                width: 210px;
                height: 36px;
                line-height: 36px;
            }
            .el-button{
                min-width: 60px;
            }
        }
    }
}
</style>
